module.exports = __webpack_public_path__ + "img/Avatar-4.87cff309.gif";